/* eslint-disable react-hooks/exhaustive-deps */
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { getBaseUrl } from '@plone/volto/helpers';
import { defineMessages } from 'react-intl';
import rightArrowSVG from '@plone/volto/icons/right-key.svg';
import { Link } from 'react-router-dom';
import { Icon } from '@plone/volto/components';
import { useDispatch } from 'react-redux';
import { syncEsperienza } from '@package/actions';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const messages = defineMessages({
  syncEsperienza: {
    id: 'syncEsperienza',
    defaultMessage: 'Sincronizza da Trekksoft',
  },
});

const SyncMenu = ({ content, pathname, intl }) => {
  const path = getBaseUrl(pathname);

  const trekksoftSync = useSelector((state) => state.trekksoftSync);
  const doSync = () => {
    dispatch(syncEsperienza(path));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (trekksoftSync?.loaded) {
      if (trekksoftSync?.sync?.sync === 'ok') {
        if (trekksoftSync?.sync?.fields_updated?.length > 0) {
          toast.success(
            `Sincronizzazione completata. Campi aggiornati: ${trekksoftSync?.sync?.fields_updated.join(
              ', ',
            )}`,
          );
        } else {
          toast.success('Sincronizzazione completata.');
        }
      } else {
        toast.error('Sincronizzazione fallita.');
      }
    } else if (trekksoftSync?.loading) {
      toast.info('Sincronizzazione in corso...');
    }
  }, [trekksoftSync?.loaded, trekksoftSync?.sync]);

  const dispatch = useDispatch();

  return (
    content?.['@type'] === 'Esperienza' && (
      <>
        <Plug pluggable="toolbar-more-manage-content" id="sync-menu">
          <li>
            <Link onClick={() => doSync()}>
              <div>
                <span className="pastanaga-menu-label">
                  {intl.formatMessage(messages.syncEsperienza)}
                </span>
                <span className="pastanaga-menu-value" />
              </div>
              <Icon name={rightArrowSVG} size="24px" />
            </Link>
          </li>
        </Plug>
      </>
    )
  );
};

export default SyncMenu;
